/***
 * @file:
 * @author: yeqing.qi
 * @Date: 2021-06-15 16:46:40
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { TabComponent } from './tab.component';
@NgModule({
  declarations: [TabComponent],
  imports: [NzTabsModule, CommonModule, TranslateModule],
  exports: [TabComponent],
})
export class DtTabModule {}
